import {type InitialState, type Actions, ACTION_TYPES} from "./types";

const initialState: InitialState = {
    course: {},
    lesson: {},
    task: {},
    test: {},
    testSubmition: {},
}

const userStore = (state:InitialState = initialState, {type, payload}: Actions) => {
    switch(type) {
        case ACTION_TYPES.LOAD_COURSES_SUCCESS:
            if (!Array.isArray(payload)) {
                return state;
            }
            //@ts-ignore
            const course = payload.reduce((acc, curr) => {
                //@ts-ignore
                acc[curr.id] = curr;
                return acc;
            }, {});

            return {
                ...state,
                course: {
                    ...state.course,
                    ...course,
                },
            };
        case ACTION_TYPES.LOAD_LESSONS_SUCCESS:
            if (!Array.isArray(payload)) {
                return state;
            }
            //@ts-ignore 
            const lesson = payload.reduce((acc, curr) => {
                //@ts-ignore
                acc[curr.id] = curr;
                return acc;
            }, {});
            return {
                ...state,
                lesson,
            };
        case ACTION_TYPES.LOAD_TASKS_SUCCESS:
            //@ts-ignore
            const task = payload.reduce((acc, curr) => {
                //@ts-ignore
                acc[curr.id] = curr;
                return acc;
            }, {});
            return {
                ...state,
                task,
            };
        case ACTION_TYPES.LOAD_TEST_SUCCESS:
            return {
                ...state,
                test: {
                    ...state.test,
                    //@ts-expect-error,
                    [payload.id]: payload,
                }
            };
        case ACTION_TYPES.LOAD_TEST_LAST_SUBMITION_SUCCESS: 
            return {
                ...state,
                testSubmition: {
                    ...state.testSubmition,
                    //@ts-expect-error,
                    [payload.id]: payload,
                }
            }
        case ACTION_TYPES.CHANGE_TEST_STATUS:
            const newTestSubmition = {
                //@ts-expect-error
                ...state.testSubmition[payload.id],
                //@ts-expect-error
                state: payload.state,
            }
            return {
                ...state,
                testSubmition: {
                    ...state.testSubmition,
                    //@ts-expect-error,
                    [payload.id]: newTestSubmition,
                }
            }
        default: 
            return state;
    }
}

export default userStore;